import { render, staticRenderFns } from "./Observacao.vue?vue&type=template&id=1f8729da"
import script from "./Observacao.vue?vue&type=script&lang=js"
export * from "./Observacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports